var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"rounded-lg pr-4 pl-4",attrs:{"elevation":"3"}},[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{staticClass:"pa-2",attrs:{"cols":"12","md":"5"}},[_c('v-subheader',{class:{
        't-mobile': _vm.$vuetify.breakpoint.xsOnly
      }},[_c('h2',[_vm._v(_vm._s(_vm.title))])])],1),_c('v-col',{staticClass:"d-flex justify-sm-end pa-0",attrs:{"cols":"12","md":"7"}},[_c('v-breadcrumbs',{class:{
        'p-mobile': _vm.$vuetify.breakpoint.xsOnly
      },attrs:{"items":_vm.breadcrumbsItems,"large":""},scopedSlots:_vm._u([{key:"divider",fn:function(){return [_c('v-icon',[_vm._v("mdi-chevron-right")])]},proxy:true}])})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }